/**
 * applyDelay - Mobile audio connection delay (ElevenLabs pattern)
 *
 * Android: Needs ~3s after getUserMedia for AudioManager to switch to correct audio mode.
 * Without it, the beginning of the first message can be cut off.
 * iOS: Default 0, but configurable (e.g. if similar issues occur).
 *
 * @param {Object} delayConfig - { default, android, ios } in ms
 * @returns {Promise<void>}
 */
import { getDeviceInfo } from './MicPermissionUtils.js';

export async function applyDelay(delayConfig = { default: 0, android: 3000, ios: 0 }) {
  const { isIOS, isAndroid } = getDeviceInfo();

  let delay = delayConfig.default ?? 0;
  if (isAndroid) {
    delay = delayConfig.android ?? delay;
  } else if (isIOS) {
    delay = delayConfig.ios ?? delay;
  }

  if (delay > 0) {
    console.log(`📱 applyDelay: waiting ${delay}ms for mobile audio session (${isAndroid ? 'Android' : 'iOS'})`);
    await new Promise((resolve) => setTimeout(resolve, delay));
  }
}
